import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-brand">PICKTECH</h3>
          <p className="footer-description">
            Innovative technology solutions for modern businesses. Transforming
            ideas into digital reality with our WebCraft Pro platform.
          </p>
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/company/picktechau/?viewAsMember=true"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <img
                src="/images/linkedinlogo.png"
                alt="LinkedIn"
                className="linkedin-logo"
              />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/webcraft">WebCraft</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Our Services</h4>
          <ul className="footer-links">
            <li>
              <Link to="/webcraft">Custom Web Development</Link>
            </li>
            <li>
              <a href="https://waitingq.au/" target="_blank" rel="noreferrer">
                WaitingQ
              </a>
            </li>
            <li className="inactive-service">
              <span>StampGo</span>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Contact Us</h4>
          <ul className="footer-contact-info">
            <li>
              <i className="fas fa-map-marker-alt"></i> Lidcombe, NSW, Australia
            </li>
            <li>
              <i className="fas fa-phone-alt"></i> +61 414 989 606
            </li>
            <li>
              <i className="fas fa-envelope"></i> jacob.yu.webdev@gmail.com
            </li>
            <li>
              <i className="fas fa-clock"></i> Mon-Fri: 9:00 AM - 6:00 PM
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">
          &copy; {new Date().getFullYear()} PICKTECH. All Rights Reserved.
        </p>
        <div className="footer-legal-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
